import React, {useState} from 'react';

import './DatasetToggleCard.scss';
import {IDatasetPropsConfig} from "./common/api/interfaces/interfaces";
import {InputSwitch} from "primereact/inputswitch";
import {truncateDate} from "utils/time-utils";
import {DatasetDataApi} from "api/DatasetDataApi";
import {UpdateDatasetData} from "api/requests";
import {TitleOverrideAndDescriptionTemplate} from "../../templates/DataTableCellTemplates";

const DatasetToggleCard = (props: IDatasetPropsConfig) => {

    const [buttonValue, setButtonValue] = useState<boolean>(props.value);

    const buttonPressed = (value: boolean) => {
        let dateString: string;
        if (props.truncateTo) {
            dateString = truncateDate(new Date(), props.truncateTo).toISOString();
        } else {
            dateString = new Date().toISOString();
        }

        let newValue = 0;
        if (value) {
            newValue = 1;
        }

        let tempArr: Array<UpdateDatasetData> = [
            {
                "identifier": props.result.identifier as string,
                "values": {[dateString]: newValue}
            }
        ]

        DatasetDataApi.updateData(tempArr)
            .then((res) => {
                let detail: string = "Dataset have been turned off"
                if (value) {
                    detail = "Dataset have been turned on"
                }
                if (res.data) {
                    if (res.data.length > 0) {
                        props.showToast('success', 'Success', detail)
                    }
                }
                setButtonValue(value);
            })
            .catch((err) => {
                console.error(err);
            })
    }

    return (
        <div className={"toggle-card-full-row"}>
            <div className={"text-field"}>
                <div className={"text-side"}>
                    {TitleOverrideAndDescriptionTemplate({
                        title: props.result.title,
                        overriddenTitle: props.config.overriddenTitle,
                        description: props.config.description
                    })}
                </div>
            </div>
            <InputSwitch className={"button-prime"}
                         checked={buttonValue}
                         onChange={(e) => buttonPressed(e.value)}
            />
        </div>
    );
};

export default DatasetToggleCard;